<template>
  <v-card-subtitle class="small-subtitle" data-cy="lastDeviceMeasurementText">
    <span :class="{ inactiveTimestamp: !activeLastHour }">
      <span class="lastMeasurementShort">
        {{ $t('map.popover.timestamp.lastMeasurementShort') }}:
      </span>
      <span class="lastMeasurement"> {{ $t('map.popover.timestamp.lastMeasurement') }}: </span>
      <span class="value">
        {{
          timestamp != $t('map.popover.timestamp.lastMeasurementNever')
            ? new Date(timestamp).toLocaleString()
            : timestamp
        }}
      </span>
    </span>
  </v-card-subtitle>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { activeLastHour, validateTimestamp } from '@/services/device-status'
import { isValidObject } from '@/helpers/common/validationHelper'
import { NAMESPACES } from '@/store/types'
import { DEVICE_GETTERS } from '@/store/devices'
import type { GetterByDeviceId } from '@/components/devicePopover/types'
import type { SensorReadings } from '@/services/device-service/devices'

export default defineComponent({
  name: 'PopoverLastTelemetryTimestamp',
  props: {
    deviceId: {
      type: String,
      default: ''
    }
  },
  computed: {
    lastContact(): string {
      const getter = this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_LAST_CONTACT_BY_DEVICE_ID}`
      ] as GetterByDeviceId<string>
      return getter(this.deviceId)
    },
    activeLastHour(): boolean {
      return activeLastHour(this.lastContact)
    },
    sensorReadings(): SensorReadings {
      const getter = this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_SENSOR_READINGS_BY_DEVICE_ID}`
      ] as GetterByDeviceId<SensorReadings>
      return getter(this.deviceId)
    },
    timestamp(): string {
      const noTS = this.$t('map.popover.timestamp.lastMeasurementNever')
      if (!isValidObject(this.sensorReadings)) {
        return noTS
      }
      const readings = Object.values(this.sensorReadings)
      const firstReading = readings.length > 0 ? readings[0] : null
      return validateTimestamp(firstReading?.timestamp, noTS)
    }
  }
})
</script>

<style lang="scss" scoped>
.v-card-subtitle {
  opacity: 1;
}
.lastMeasurementShort {
  display: none;
}
.lastMeasurement {
  display: unset;
}
.widget-sm,
.widget-xs,
.widget-xxs {
  .measurement {
    width: 96px;
    max-width: 96px;
  }
}
.widget-xs,
.widget-xxs {
  .lastMeasurementShort {
    display: unset;
  }
  .lastMeasurement {
    display: none;
  }
}

.inactiveTimestamp {
  color: #fa1717;

  .value {
    color: inherit;
    font-weight: inherit;
  }
}
</style>
